<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
  >
    <template #header>
      Subir archivo PBIX
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <UploadPbix
      ref="uploadPbixRef"
      @add-pbix="handleAddPbix"
      :loading="loadingPbix"
    />
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";
import Dialog from "primevue/dialog";
import { useStore } from "vuex";

import UploadPbix from "@/components/partials/UploadPbix.vue";

import { createPbix } from "@/api/pbix/pbix.api";

// #region Props, Emits
const emit = defineEmits(["uploaded"]);
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const toast = useToast();
const showModalRef = ref(false);
const loadingPbix = ref(false);
const uploadPbixRef = ref(null);
// #endregion

// #region Functions
async function showModal() {
  showModalRef.value = true;
}

async function handleAddPbix() {
  if (uploadPbixRef.value.validatePbix() === false) {
    toast.add({
      severity: "error",
      summary: "Error",
      detail: uploadPbixRef.value.dragAndDropErrorRef,
      life: 3000,
    });

    return;
  }

  loadingPbix.value = true;

  const file = uploadPbixRef.value.getPbixFile();
  const titulo = uploadPbixRef.value.getPbixFileName();

  const response = await createPbix({
    File: file,
    TituloPbix: titulo,
  });

  loadingPbix.value = false;

  if (response.status != 200) {
    const error = response.response?.data?.errors?.[0]?.message;

    if (error) {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
    } else {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: "Error al subir la versión",
        life: 3000,
      });
    }
  } else {
    closeModal();

    toast.add({
      severity: "success",
      summary: "Éxito",
      detail: "Archivo PBIX subido correctamente",
      life: 3000,
    });

    emit("uploaded", response.data);
  }
}

function closeModal() {
  showModalRef.value = false;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
